import { gql } from 'graphql-request';

// Check if user exists in ZEE5 by Email/Mobile
export const USER_EXISTS_QUERY = gql`
  query ($email: String, $mobile: String) {
    userExists(email: $email, mobile: $mobile)
  }
`;

// Send OTP
export const SEND_OTP_QUERY = gql`
  query ($sendOtpInput: SendOtpInput!) {
    sendOtp(sendOtpInput: $sendOtpInput) {
      __typename
      code
      message
    }
  }
`;

// Verify OTP
export const VERIFY_OTP_QUERY = gql`
  query ($verifyOtpInput: VerifyOtpInput!) {
    verifyOtp(verifyOtpInput: $verifyOtpInput) {
      __typename
      tokenType
      expiresIn
      authToken
      refreshToken
      code
      message
      shouldRegister
      secureToken
    }
  }
`;

// register user using secure token after otp verification
export const VERIFY_OTP_REGISTER_QUERY = gql`
  query ($verifyOtpRegisterInput: VerifyOtpRegisterInput!) {
    verifyOtpRegister(verifyOtpRegisterInput: $verifyOtpRegisterInput) {
      __typename
      tokenType
      expiresIn
      authToken
      refreshToken
      secureToken
      code
      message
    }
  }
`;
